import {ActiveRecord} from './ActiveRecord';

abstract class ActiveRecordResource extends ActiveRecord {

  protected async _createRecord(dataForSave) {
    let res = await this._networkLayer.postFormData(this._prepareUrl(), dataForSave);
    return await res.json();
  }

  protected async _updateRecord(dataForSave) {
    let res = await this._networkLayer.putFormData(this._prepareUrl(this.id), dataForSave);
    return await res.json();
  }

  _parseData(data) {
    if (data.image_url && typeof data.image_url === 'object') {
      data.image_url = data.image_url.original;
    }

    return data;
  }
}

export default ActiveRecordResource;



// WEBPACK FOOTER //
// ./src/api/ActiveRecordResource.ts